/**
 * POC options for the Calling Summary form dropdown.
 *
 * Every assignee in {@link PocAssignee} is listed, sorted by name, so the
 * dropdown stays in step with the enum instead of a hand-picked subset.
 */

import { PocAssignee, PocAssigneeLabels } from "../enums/pocAssignee";

export const CALLING_POC_OPTIONS = (
  Object.entries(PocAssigneeLabels) as [PocAssignee, string][]
)
  .map(([id, text]) => ({ id, text }))
  .sort((first, second) => first.text.localeCompare(second.text));
